// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__GMaCy","Blur":"Main_Blur__M9XOk","WithAside":"Main_WithAside__eaPmb"};